import Constant from '@/const';
import axios from 'axios';

const postRegisterPatient = async payload => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat('/inpatient'),
      payload,
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default postRegisterPatient;
